import React, { Fragment } from "react";
import "../Task/Task.css";

import { Container } from "reactstrap";

import heroImg from "../../assests/images/hero-img1.png";
import TaskCard from "../Task/TaskCard";
import Header from "../Header/Header";
import Navmenu from "../Navmenu/Navmenu";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../Footer/Footer";


const taskdata = [
    {
        task_id: "33",
        content_title: `Суперпозиция принципіне сәйкес өрістің магниттік индукциясы (23-сурет)

        Бұрыштарды ескере отырып,   – ді анықтаймыз. 
         , мұнда R – квадраттың центрінен оның қабырғасына дейінгі  ара қашықтық.
        `,
        id_faq: "faq_33",
        for_faq: "faq_33",
        question: `Бойымен  I =20 A тоқ күші ағып өтетін, қабырғалары a = 0,10 м кварат центріндегі өрістің магниттік индукциясын анықтаңыз.`,
        img_url: heroImg,
        answers: `# Тоғы бар сым орамы
        import math as mt
        k1=1.0e-7; a=0.1; I=20;
        B=k1*8*I*mt.sqrt(2.0)/a;
        print('B=',B)
        `,
        languages: "python",
        container_id: 33,
        img1: `Снимок экрана (1114).png`,
        img2: ``,
    },
    {
        task_id: "34",
        content_title: `Дөңгелек тоқтың маңайындағы магнит өрісінің индукциясын  өрнегімен анықтаймыз. 
        Жердің магниттік моменті  , ал дөңгелек тоқтың күші    , мұнда . 
        `,
        id_faq: "faq_34",
        for_faq: "faq_34",
        question: `Жердің магниттік өрісін магниттік дипольдің өрісі ретінде қарастыруға болады. Жер шары магнетизмінің табиғатын түсіндіретін модельдердің бірінде, жер центрінен радиусы 5000 км –дегі, жазықтығы экватор жазықтығына жақын болып келетін, жазықтықта I дөңгелек тоқ өтеді деп жорамалданған. Егер жердің магнит өрісінің маңайында магнит өрісі индукциясының B0 шамасы 0,1 мТл болса, осы тоқтың шамасын табыңыз. Жердің пішінін сфера деп есептей отырып, жер радиусын R0 = 6380 км деп алыңыз. `,
        img_url: heroImg,
        answers: `# Жердің магнит өрісі 2
        import math as mt
        mu0=4*mt.pi*1.0e-7;R0=6.38e6;R1=5.0e6;B0=1.0e-4;
        I=2*B0*(R1*R1+R0*R0)**1.5/(mu0*R1*R1);
        pm=I*mt.pi*R1*R1;
        print('I=',I,'pm=',pm)
        
        
        #Дөңгелек токтың маңындағы магниттік күш сызықтары
        import math as mt
        import matplotlib.pyplot as plt
        def sign(x):
            if(x < 0.): return -1.;
            elif(x > 0.): return 1.;
            else: return 0.;
        N2=6; N4=400;
        k1=1.0e-7; R=5000.; I=3.39e9; dalp=2*mt.pi/N4;
        B1=dalp*k1*I/R; dr=0.001; xb=[-1.,1.];
        xg=[]; zg=[];
        for xa in xb:
            for i2 in range(1,N2):
                x=xa+sign(xa)*i2*0.15; z=0.0;
                for i3 in range(0,400+i2*550):
                    BX=0.; BZ=0.; FX=0.;FZ=0.;
                    for i4 in range(1,N4):
                        alp=i4*dalp;
                        cs=mt.cos(alp);sn=mt.sin(alp);
                        r3=((x-cs)**2+sn*sn+z*z)**1.5;
                        FX1=B1*z*cs/r3;
                        FZ1=B1*((x-cs)*cs-sn*sn)/r3;
                        BX=BX+0.5*(FX1+FX);
                        BZ=BZ-0.5*(FZ1+FZ);
                        B=mt.sqrt(BX*BX+BZ*BZ);
                        FX=FX1;FZ=FZ1;
                    dx=dr*BX/B;dz=dr*BZ/B;x=x+dx;z=z+dz;
                    xg.append(x); zg.append(z);
        plt.scatter(xg,zg,c='k',s=0.5)
        plt.plot([0,0],[-0.5,0.5],c='k')
        plt.plot([-1,1],[0.,0.],c='k',lw=2)
        plt.text(0.02, 0.48, r'z',fontsize=16)
        plt.text(-0.05, -0.05, r'0',fontsize=16)
        plt.xlabel(r'$x$',fontsize=16);
        plt.ylabel(r'$z$',fontsize=16);
        plt.show()
`,
        languages: "python",
        container_id: 34,
        img1: `Снимок экрана (1115).png`,
        img2: `Снимок экрана (1116).png`,
    },
    {
        task_id: "34.1",
        content_title: `Дөңгелек тоқтың маңайындағы магнит өрісінің индукциясын  өрнегімен анықтаймыз. 
        Жердің магниттік моменті  , ал дөңгелек тоқтың күші    , мұнда . 
        `,
        id_faq: "faq_34.1",
        for_faq: "faq_34.1",
        question: `Дөңгелек тоқтың маңайындағы магнит өрісінің күш сызықтарын тұрғызайық. 
        Алдымен декарттық координат жүйесіне  орамның центрін орналастырайық, ал z осін орамның осінің бойымен бағыттайық`,
        img_url: heroImg,
        answers: `#Дөңгелек токтың маңындағы магниттік күш сызықтары
        import math as mt
        import matplotlib.pyplot as plt
        def sign(x):
            if(x < 0.): return -1.;
            elif(x > 0.): return 1.;
            else: return 0.;
        N2=6; N4=400;
        k1=1.0e-7; R=5000.; I=3.39e9; dalp=2*mt.pi/N4;
        B1=dalp*k1*I/R; dr=0.001; xb=[-1.,1.];
        xg=[]; zg=[];
        for xa in xb:
            for i2 in range(1,N2):
                x=xa+sign(xa)*i2*0.15; z=0.0;
                for i3 in range(0,400+i2*550):
                    BX=0.; BZ=0.; FX=0.;FZ=0.;
                    for i4 in range(1,N4):
                        alp=i4*dalp;
                        cs=mt.cos(alp);sn=mt.sin(alp);
                        r3=((x-cs)**2+sn*sn+z*z)**1.5;
                        FX1=B1*z*cs/r3;
                        FZ1=B1*((x-cs)*cs-sn*sn)/r3;
                        BX=BX+0.5*(FX1+FX);
                        BZ=BZ-0.5*(FZ1+FZ);
                        B=mt.sqrt(BX*BX+BZ*BZ);
                        FX=FX1;FZ=FZ1;
                    dx=dr*BX/B;dz=dr*BZ/B;x=x+dx;z=z+dz;
                    xg.append(x); zg.append(z);
        plt.scatter(xg,zg,c='k',s=0.5)
        plt.plot([0,0],[-0.5,0.5],c='k')
        plt.plot([-1,1],[0.,0.],c='k',lw=2)
        plt.text(0.02, 0.48, r'z',fontsize=16)
        plt.text(-0.05, -0.05, r'0',fontsize=16)
        plt.xlabel(r'$x$',fontsize=16);
        plt.ylabel(r'$z$',fontsize=16);
        plt.show()
        `,
        languages: "python",
        container_id: 34.1,
        img1: `34.1-мысал.gif`,
        img2: `Снимок экрана (1116).png`,
    },
    {
        task_id: "35",
        content_title: `Суперпозиция принципіне сәйкес магнит өрісінің индукциясы z=0 - де, яғни

        болғанда, магнит өрісінің индукциясы В1 түзу шексіз өткізгішпен орамның В2 өрісінің векторлық қосындысын береді. Бұранда ережесіне сәйкес В1
        және В2 векторларының бағыттары орам центрінде сәйкестенеді және орам жазықтығына перпендикуляр болып бізден бағытталған. Онда орам центріндегі қорытқы өрістің скаляр түрі төмендегідей өрнекпен жазылады:
        
        Бұдан тоқ үшін есептеу формуласын аламыз.
        `,
        id_faq: "faq_35",
        for_faq: "faq_35",
        question: `Түзу шексіз ұзын өткізгіштің  радиусы  R=0.8 м дөңгелек тұзағы бар. Егер дөңгелек тұзақ центріндегі магнит индукциясының шамасы B=12.5 мкТл-ға тең екендігі белгілі болса, онда  өткізгіштегі тоқ күшін анықтаңыз, `,
        img_url: heroImg,
        answers: `# Тогы бар дөңгелек тұзақ
        import math as mt
        k1=1.0e-7; R=0.8; B=1.25e-5;
        I=B*R/(2*k1*(mt.pi+1.0));
        print('I=',I)
        `,
        languages: "python",
        container_id: 35,
        img1: `Снимок экрана (1117).png`,
        img2: ``,
    },
    {
        task_id: "36",
        content_title: `Магнит өрісінде электронға әсер ететін Лоренц күші    мұндағы B=Bj = (0, B, 0)  немесе  

        Электрон қозғалысының теңдеуін жазамыз?  , декарттық координаталар жүйесінде 
        Жоғарғы теңдеудегі жүйенің оң жағын t айнымалысы бойынша дифференциалдасақ және алынған нәтижені төменгі теңдеуге апарып қоятын болсақ, онда       . Екінші ретті бір текті дифференциалдық теңдеудің  шешімі  . Осы теңдеуді t  айнымалысы бойынша дифференциалдап және алынған нітижені жоғарғы теңдеуге апарып қоятын болсақ, онда  үшінжалпы шешімнің түрі келесідей болады: . Интегралдау тұрақтысын анықтау үшін, алғашқы шартты қолданамыз  
Сонымен келесі өрнекті аламыз:  
Катушканың белсенді аймағындағы электрондардың ұшу t ұзақтығын анықтаймыз. Ол үшін дифференциалдық теңдеуді интегралдаймыз, яғни  

Ауытқу бұрышы     
Электронның бастапқы жылдамдығы энергияның сақталу заңынан анықталынады: /2= qU `,
        id_faq: "faq_36",
        for_faq: "faq_36",
        question: `Үдетуші потенциалдар айырымы U=20 кэВ –қа тең электрондық-сәулелік түтікшедегі электрондар шоғын вертикаль ауытқытушы катушка  B=5 мТл бір текті магнит өрісін тудырады. Катушка ішінлегі магнит өрісі, 27-суретте көрсетілгендей, y осі бойымен бағытталған. Уақыттың бастапқы мезетіндегі электрондар жылдамдығы  ,    Катушка сыртындағы магнит өрісін ескермеуге болады. Егер катушканың жұмыс жасау аймағының ұзындығы    болса, онда электрондар шоғы қандай бұрышқа ауытқиды?`,
        img_url: heroImg,
        answers: `# Электрондық-сәулелік түтікшедегі электрондар шоғы 1
        import math as mt
        q=1.6e-19; m=9.1e-31; U=2.0e4; B=5.0e-3; l=0.02;
        v0=mt.sqrt(2*q*U/m); omega=q*B/m; R=v0/omega;
        phi=-mt.asin(l/R);
        print('phi=',phi,'rad =',phi*180/mt.pi,'deg')
        `,
        languages: "python",
        container_id: 36,
        img1: `Снимок экрана (1118).png`,
        img2: `Снимок экрана (1121).png`,
    },
    {
        task_id: "36.1",
        content_title: `Бастапқы шарт бойынша    
        Жүйедегі бірінші теңдеуді интегралдасақ, онда мынадай шешімге келеміз
         , ал жүйедегі екінші теңдеуді интегралдасақ, онда
           өрнегін аламыз.
        Электрон шоғы траекториясының параметрлік теңдеуі төменде келтірілген теңдеуге сәйкес келеді:
        немесе    
        Катушкадағы қозғалыс траекториясы шеңбердің доғасы болып табылады. Ол радиусы         және центрі   мына    нүктеде  ( 0, 0,  -R ) болатын      у =0 жазықтығында жатады.         `,
        id_faq: "faq_36.1",
        for_faq: "faq_36.1",
        question: `Электрондық-сәулелік түтікше жүйесіндегі белсенді аймақта электронның траекториясын тұрғызайық. Электрондық шоқ траекториясының теңдеуін жүйедегі бір біріне байланыссыз дифференциалдық теңдеулерді интегралдау арқылы табамыз.        `,
        img_url: heroImg,
        answers: `# Электрондық-сәулелік түтікшедегі электрондар шоғы 2
        import math as mt
        import matplotlib.pyplot as plt
        q=1.6e-19; m=9.1e-31; U=2.0e4; B=5.0e-3; l=0.02;
        v0=mt.sqrt(2*q*U/m); omega=q*B/m; R=v0/omega;
        phi=-mt.asin(l/R); t1=abs(phi)/omega;
        def x(t):
            return R*mt.sin(omega*t);
        def z(t):
            return R*mt.cos(omega*t)-R;
        print('R=',R,'Dz=',z(t1))
        tmin=0.0; tmax=t1; NT=5000; dt=(tmax-tmin)/NT;
        xx=[]; zz=[];
        xx.append(x(0)); zz.append(z(0));
        for i in range(1,NT):
            t=tmin+i*dt;
            xx.append(x(t)); zz.append(z(t));
        plt.plot(xx,zz,'k-')
        plt.grid(True)
        plt.xlabel('$x,\;м$',fontsize=20)
        plt.ylabel('$z,\;м$',fontsize=20)
        plt.show()
        `,
        languages: "python",
        container_id: 36.1,
        img1: `36.1-мысал.gif`,
        img2: `Снимок экрана (1121).png`,
    },
    {
        task_id: "37",
        content_title: `у осі  магнит өрісі сызықтарының бойымен бағытталған. Координат басын және z осін, алғашқы шарт төменде келтірілген шарт арқылы таңдауға мүмкіндік беретіндей етіп таңдаймыз.
        0      және     
        Уақыттың кез келген мезетінде жылдамдықтың компоненттері 
        
        және циклдік жиілік     өрнегімен анықталады.
        Алғашқы шартты ескере отырып, бұл теңдеулерді интегралдау арқылы координаталар үшін келесі өрнекті алуға болады:
        
        
        мұндағы    - электрон траекториясы оралатын цилиндр радиусы, цилиндр осі у осіне параллель және ол у = 0 жазықтығын координаттары  (0, -R) нүктеде қияды, ал спираль сызық қадамын
            шартынан табамыз.
        `,
        id_faq: "faq_37",
        for_faq: "faq_37",
        question: `Вакуумда     жылдамдықпен қозғалып келе жатқан электрон, индукциясы     бір текті магнит өрісінің күш сызықтарына    бұрышпен келіп кіреді. Электрон қозғалатын спирал сызықтың радиусын  R   және оның  h  қадамын анықтаңыз.
        `,
        img_url: heroImg,
        answers: `# Спираль сызықтары 1
        import numpy as np
        import matplotlib.pyplot as plt
        from mpl_toolkits.mplot3d import Axes3D
        q=1.6e-19;m=9.1e-31;v0=2.0e6;B=1.2e-3;teta=np.pi/4;
        omega=q*B/m; T=2*np.pi/omega;
        R=v0*np.sin(teta)/omega; h=v0*np.cos(teta)*T;
        print('R=',R,'h=',h)
        t = np.linspace(0, 2*T, 100)
        x = R*np.sin(omega*t);
        y = v0*t*np.cos(teta);
        z = R*np.cos(omega*t)-R;
        fig = plt.figure()
        ax = fig.gca(projection='3d')
        ax.plot(x, z, y)
        plt.xlabel('x')
        plt.ylabel('z')
        plt.show()
        `,
        languages: "python",
        container_id: 37,
        img1: `37-мысал.gif`,
        img2: `Снимок экрана (1123).png`,
    },
    {
        task_id: "38",
        content_title: `Магнит индукциясы векторының циркуляциясын төменде келтірілген өрнек арқылы анықтаймыз. 


        j – тоқ тығыздығының  векторы
        S – контурмен шектелген беттің ауданы
         , мұндағы α – тоқ тығыздығы j  векторы мен S бетке түсірілген n бірлік вектор арасындағы бұрыш.
        `,
        id_faq: "faq_38",
        for_faq: "faq_38",
        question: `Тоқ өткізгіштің қимасының бойымен       тығыздықпен біркелкі таралған. Өткізгіштің ішімен өтетін және j тоқ  тығыздығы векторымен оның жазықтығы   бұрыш құратындай болып бағдарланған, радиусы  R = 5 мм шеңбер бойымен жүретін магнит индукциясы векторының циркуляциясын табыңыз.`,
        img_url: heroImg,
        answers: `# Тогы бар өткізгіштегі магнит өрісінің циркуляциясы
        import math as mt
        mu0=4*mt.pi*1.0e-7;R=0.005;j=2.0e6;beta=mt.pi/6;
        C=mu0*j*mt.cos(mt.pi/2-beta)*(mt.pi*R*R);
        print('C=',C)
        `,
        languages: "python",
        container_id: 38,
        img1: `Снимок экрана (1124).png`,
        img2: ``,
    },
    {
        task_id: "39",
        content_title: `⦁	Шеңбер өткізгіштің осіне перпендикуляр жазықтықта жатыр. Эрстед заңы бойынша келесі өрнекті жазуға болады: 



        ⦁	Эрстед заңы бойынша келесі өрнекті жазуға болады: 
        `,
        id_faq: "faq_39",
        for_faq: "faq_39",
        question: `
        Радиусы R=1 см ұзын түзусызықты біртекті өткізгіштің бойымен I=50A тоқ ағып өтеді. 
        ⦁	Остік сызықтан   қашықтықтағы өткішгіштің ішіндегі өрістің магниттік индукциясын анықтаңыз. 
        ⦁	Остік сызықтан   қашықтықтағы өткішгіштің сыртындағы өрістің магниттік индукциясын неге тең болады?.
        `,
        img_url: heroImg,
        answers: `#Тоғы бар өткізгіштегі өрістің магниттік индукциясы
        import math as mt
        mu0=4*mt.pi*1.0e-7; R=0.01; I=50; r1=0.008; r2=0.05;
        B1=mu0*I*r1/(2*mt.pi*R*R); B2=mu0*I/(2*mt.pi*r2);
        print('B1=',B1,'B2=',B2)
        `,
        languages: "python",
        container_id: 39,
        img1: `39-мысал 1-мысал.gif`,
        img2: `39-мысал 2-вариант.gif`,
    },
    {
        task_id: "40",
        content_title: `Тор (Тороид) – дөңгелектің жазықтығында жататын, бірақ онымен қилыспайтын түзудің айналасында дөңгелектің айналуынан пайда болатын дене.`,
        id_faq: "faq_40",
        for_faq: "faq_40",
        question: `Диэлектрлік материалдан жасалған жұқа тороидқа орамдары бірқалыпты таралатындай етіп N = 1000  орамнан тұратын катушка оралған. Егер катушка бойымен I=10 А тоқ өтсе, онда жұқа катушканың осіндегі магнит өрісі индукциясының тороид центріндегі магнит өрісінің индукциясына қатынасы қандай болады?. Катушканың радиусы   , тароидтың радиусы  .`,
        img_url: heroImg,
        answers: `# Тороидтың магнит өрісінің индукциясы
        import math as mt
        mu0=4*mt.pi*1.0e-7; R1=0.005; R2=0.25; I=10; N=1000;
        B1=mu0*N*I/(2*mt.pi*R2); B2=mu0*I/(2*R2);
        print('B1=',B1,'B2=',B2,'\nB1/B2=',B1/B2)
        `,
        languages: "python",
        container_id: 40,
        img1: `Снимок экрана (1126).png`,
        img2: ``,
    },
    {
        task_id: "41",
        content_title: `Қабырғасы a = 20 см жазық квадрат рама, бойынан  I = 100 А тоқ өтетін  шексіз түзу өткізгішпен бір жазықтықта орналасқан. Рамканың бір қабырғасы түзу өткізгішке жақын параллель және одан x1 = 10 см қашықтықта орналасқан. Рамканы қиып өтетін магнит ағынын анықтаңыз.
        , мұндағы n –рамканың жазықтығына перпендикуляр бірлік вектор. В - рамка жазықтығындағы магнит индукциясының векторы.  
        
        Тоғы бар түзу өткізгіштегі магнит өрісінің индукциясы   .
        `,
        id_faq: "faq_41",
        for_faq: "faq_41",
        question: `Қабырғасы a = 20 см жазық квадрат рама, бойынан  I = 100 А тоқ өтетін  шексіз түзу өткізгішпен бір жазықтықта орналасқан. Рамканың бір қабырғасы түзу өткізгішке жақын параллель және одан x1 = 10 см қашықтықта орналасқан. Рамканы қиып өтетін магнит ағынын анықтаңыз.
        , мұндағы n –рамканың жазықтығына перпендикуляр бірлік вектор. В - рамка жазықтығындағы магнит индукциясының векторы.  
        
        Тоғы бар түзу өткізгіштегі магнит өрісінің индукциясы   .
        `,
        img_url: heroImg,
        answers: `# Квадрат рамка арқылы өтетін магнит өрісінің индукциясының ағымы
        import math as mt
        k1=1.0e-7; a=0.2; x1=0.1; x2=0.3; I=100;
        Phi=k1*2*I*a*mt.log(x2/x1);
        print('Phi=',Phi)
        `,
        languages: "python",
        container_id: 41,
        img1: `Снимок экрана (1127).png`,
        img2: ``,
    },
    {
        task_id: "42",
        content_title: `Есептің шартындағы түсініктеме біздің көз алдымызға электрмагниттік зеңбіректі елестете алады. Зеңбіректің аралық CD қабырғасына әсер ететін ампер күші   
        – үйкеліс күші.
       
       Ньютон қозғалысының теңдеуін жазамыз:
       
       
       
       Қозғалыс бағытындағы a, F, mg, F1 векторларының проекциясын ескере отырып, келесі теңдеуді аламыз:
       
       
       
       Өріс индукциясының минималь шарты,  екендігін білдіреді.
       `,
        id_faq: "faq_42",
        for_faq: "faq_42",
        question: `Бір бірінен l = 0,30 м  қашықтықта орналасқан және екі рельстің бойында көлденең жатқан массасы m = 0,14 кг мыс стержн бойымен  I = 50 А тоқ өтеді. Рельстер бойымен сырғанау үйкелісінің коффициенті .  Өткізгіш рельс бойымен қозғалысын бастаған мезеттегі магнит өрісінің минималь    индукциясын анықтаңыз.`,
        img_url: heroImg,
        answers: `# Электромагниттік зеңбірек
        g=9.8; mu=0.6; m=0.14; l=0.3; I=50;
        Bmin=mu*m*g/(I*l);
        print('Bmin=',Bmin)
        `,
        languages: "python",
        container_id: 42,
        img1: `Снимок экрана (1128).png`,
        img2: ``,
    },
    {
        task_id: "43",
        content_title: `Есептің шарты бойынша белбеулердің ұзындығы, олардың бір-бірінен қашықтығымен салыстырғанда бірнеше есе үлкен екенін байқауға болады.  Өзара тебіліс күші келесі өрнекпен анықталады.


        Тоғы бар түзу өткізгіштің бөлігіндегі магнит өрісінің индукциясы:
        
        мұндағы – өткізгіш және өткізгіш басынан бақылау нүктесі бағыты арасындағы бұрыш,  - өткізгіш және өткізгіш соңынан бақылау нүктесі бағыты арасындағы бұрыш (32-суретті қараңыз). Тригонометриялық қатынастан косинусты оңай табуға болады:
         ,                    
        Ампер күші x осінің бойымен бағытталған және скаляр түрде төмендегідей болып жазылады:
        
        Тригонометриялық қатынастан анықталған косинустың өрнегін қолданып, интегралды келесі түрде жазамыз:
        `,
        id_faq: "faq_43",
        for_faq: "faq_43",
        question: `Генераторлардың белбеулерін бір-бірінен d = 20 см қашықтықта орналасқан екі параллель мыстан жасалған жолақтар ретінде  елестетуге болады (32-сурет). Белбеулердің бойымен тоқ жүрген кезде, олардың қысқа тұйықталу жағдайындағы өзара тебіліс күшін анықтаңыздар.`,
        img_url: heroImg,
        answers: `# Қысқа тұйықталу 2
        import math as mt
        k1=1.0e-7; L=2.0; d=0.2; IZ=10000;
        F0=k1*2*IZ*IZ*L/d;
        F1=k1*2*IZ*IZ*(mt.sqrt(d*d+L*L)-d)/d;
        dF=abs(F0-F1)/F1;
        print('F0=',F0,'F1=',F1,'\ndF=',dF)
        `,
        languages: "python",
        container_id: 43,
        img1: `Снимок экрана (1130).png`,
        img2: ``,
    },
    {
        task_id: "44",
        content_title: `Есептің шарты бойынша онда    –тең. Магниттік индукция орамның магниттік моментімен келесі өрнек бойынша байланысқан. 


        R   және    мәндерін біле отырып, тоқ күшін анықтауға болады. 
        `,
        id_faq: "faq_44",
        for_faq: "faq_44",
        question: `Дөңгелек орамның центріндегі магнит өрісінің  кереулігі H = 200 А/м. Тоғы бар орамның магниттік моменті  . Орамның радиусын және орамдағы тоқ күшін анықтаңыз.`,
        img_url: heroImg,
        answers: `# Тогы бар дөңгелек орам
        import math as mt
        k1=1.0e-7; mu0=4*mt.pi*1.0e-7; H=200; pm=1;
        B=mu0*H; R=(k1*2*pm/B)**(1/3); I=pm/(mt.pi*R*R);
        print('B=',B,'R=',R,'\nI=',I)
        `,
        languages: "python",
        container_id: 44,
        img1: `Снимок экрана (1131).png`,
        img2: ``,
    },
    {
        task_id: "45",
        content_title: `⦁	Айналыс осінен r қашықтықтағы стерженде орналасқан заряд элементі dQ арқылы анықталатын тоқ күші :

 

        T – стерженнің айналыс периоды.  Ал магниттік момент үшін келесі өрнекті жазамыз:
        
        
        λ – бірқалыпты таралған зарядтың сызықтық тығыздығы.
        
        Алынған өрнекті келесі түрде түрлендіріп    және 0-ден R – ге дейін интегралдап келесі өрнекті аламыз: 
        
        
        ⦁	Стерженнің импульс   L  моментін мына формуладан анықтаймыз:
        
        Іздеп отырған қатынасымыз    =  R/m = Q/2m
        `,
        id_faq: "faq_45",
        for_faq: "faq_45",
        question: `Ұзындығы    жұқа стержень бойымен   заряд бірқалыпты таралған. Стержень оның центрі арқылы өтетін  және оған перпендикуляр остің маңайында тұрақты бұрыштық жылдамдықпен  айналысқа түседі. Анықтау керек:
        ⦁	Зарядталған стерженнің айналысқа қатысуынан болатын  магниттік моментін;
        ⦁	Егер стерженнің массасы  m = 12.0 г. болса, онда магниттік моменттің импульс моментіне қатынасы неге тең болады?
        `,
        img_url: heroImg,
        answers: `# Зарядталған стерженнің айналысы
        import math as mt
        l=0.2; Q=2.4e-7; omega=10; m=0.012;
        R=l/2;lam=Q/l; pm=lam*omega*R**3/3;
        I=m*R**2/3; L=I*omega; pmL=Q/2/m; pmL1=pm/L;
        print('pm=',pm,'L=',R,'\npmL=',pmL,'pmL1=',pmL1)
        `,
        languages: "python",
        container_id: 45,
        img1: `Снимок экрана (1132).png`,
        img2: ``,
    },
    {
        task_id: "46",
        content_title: `Магниттік момент     

        Механикалық момент магниттік моментпен байланысты: 
        
        
        
         - магнит өрісі индукция векторымен магнит моменті векторының арасындағы бұрыш.
        `,
        id_faq: "faq_46",
        for_faq: "faq_46",
        question: `N = 200 жіңішке сым орамы бар, ұзындығы a = 4 см,  ені b = 1.5 см гальванометр рамасы индукциясы B =0.1 Тл магнит өрісінде орналасқан. Рама жазықтығы индукция сызықтарына параллель. Табу керек:
        ⦁	орам бойымен  тоқ өткен кезде рамаға әсер ететін М механикалық моменттін;
        ⦁	осы тоқ шамасындағы раманың     магниттік моментін.
        `,
        img_url: heroImg,
        answers: `# Тоғы бар гальванометр рамкасы
        B=0.1; N=200; a=0.04; b=0.015; I1=0.001;
        pm=N*I1*a*b; M=pm*B
        print('pm=',pm,'M=',M)
        `,
        languages: "python",
        container_id: 46,
        img1: `Снимок экрана (1133).png`,
        img2: ``,
    },
    {
        task_id: "47",
        content_title: `Суперпозиция принципі бойынша өрістің қорытқы магниттік индукциясы   мұндағы В0  - жердің магнит өрісінің индукциясы, В1 – тоғы бар орамның магнит өрісінің индукциясы. Тоғы бар орам компастың магниттік тілшесін ауытқытады. 34-суретте жердің магнит өрісінің SN күш сызықтары көрсетілген, Жердің магнит өрісінің индукциясының  орташа мәні   Дөңгелек орамның центріндегі магнит өрісінің  В1 индукциясы 


        Есептің шарты бойынша компастың тілшесі  бұрышқы ауытқыған, олай болса
        `,
        id_faq: "faq_47",
        for_faq: "faq_47",
        question: `Радиусы R = 0.2 м сым орамы магниттік Жер меридианасының жазықтығында орналасқан. Орамның центріне компас орнатылған. Егер компастың магниттік тілшесі магниттік меридиана жазықтығынан  бұрышқа ауытқыған болса, онда орам арқылы қандай тоқ жүріп өтеді.`,
        img_url: heroImg,
        answers: `#Отклонение стрелки компаса(компастың ауытқуы)
        import math as mt
        k1=1.0e-7;
        R=0.2; alp=9*mt.pi/180; B0=2.0e-5;
        B1=B0*mt.tan(alp); I=B1*R/(k1*2*mt.pi);
        print('I=',I)
        `,
        languages: "python",
        container_id: 47,
        img1: `Снимок экрана (1135).png`,
        img2: ``,
    },
    {
        task_id: "48",
        content_title: `Соленоидтағы магнит өрісі бір текті, сондықтан көлденең қимасы арқылы өтетін магнит ағыны  Ф келесі өрнекпен анықталады.

        (1)
       
       Соленоидтағы өрістің кернеулігі H = n*I
       `,
        id_faq: "faq_48",
        for_faq: "faq_48",
        question: `
        Болат  өзекшесі бар тұйық соленоид ұзындығының әр сантиметріне 10 орамнан келеді.  Соленоид бойымен  I = 1,25 А тоқ өтеді. Қимасы S = 4 см2
        өзекшедегі Ф магнит ағынын есептеңіз.
        `,
        img_url: heroImg,
        answers: `# Тороид бар соленойд
        n=1000; S=4.0e-4; I=1.25;
        H=n*I;
        print('H=',H)
        `,
        languages: "python",
        container_id: 48,
        img1: `Снимок экрана (1136).png`,
        img2: `Снимок экрана (1137).png`,
    },
    {
        task_id: "48.1",
        content_title: `Соленоидтағы магнит өрісі бір текті, сондықтан көлденең қимасы арқылы өтетін магнит ағыны  Ф келесі өрнекпен анықталады.

        (1)
       
       Соленоидтағы өрістің кернеулігі H = n*I
       Магнит өрісі кернеулігі   болған кездегі магнит өрісі В индукциясының мәнін табу үшін сызықты интерполяцияны қолданамыз:
 интервалындағы сызықтық интерполяция бойынша 

Магнит ағынын  (1) өрнек бойынша анықтаймыз
       `,
        id_faq: "faq_48.1",
        for_faq: "faq_48.1",
        question: `Есептер жинағындағы  магнит өрісі индукциясының магнит өрісі кернеулігіне қатысты байланыс тәуелділігін көрсететін кестеден келесі мәндерді табуға болады`,
        img_url: heroImg,
        answers: `#2A тоғы бар Тороид
        n=1000; S=4.0e-4; I=1.25;
        H=n*I;
        print('H=', H)
        H1=1000; H2=1500; B1=1.12; B2=1.25;
        B=B1+(B2-B1)*(H-H1)/(H2-H1);
        Phi=B*S;
        print('B=',B,'Phi=',Phi)
        `,
        languages: "python",
        container_id: 48.1,
        img1: `Снимок экрана (1136).png`,
        img2: `Снимок экрана (1137).png`,
    },
    {
        task_id: "49",
        content_title: `Толық тоқ заңын қолданамыз және саңылау аймағын қоса есептегенде өзекшенің ішіндегі магнит өрісі біртекті деп есептейміз. Олай болатын болса, онда циркуляцияны  түрінде елестетуге болады: өзекшедегі және саңылау аймағындағы магнит өрісінің кернеулігі. 

        Толық тоқ (Эрстед заңы) заңы – қандай да бір  Г контур бойындағы магнит өрісі кернеулігі Н векторының циркуляциясы, осы контурды қамтитын макроскопиялық   тоқтардың алгебралық қосындысына тең:
        
         ,       ,      
        
          (1)
        
        Ауадағы магнит өрісінің кернеулігі мен индукциясының арасындағы байланысты    (2) өрнегі арқылы жазамыз.
         – магниттік тұрақты. 
        
        (1)–ші теңдеуді  –ға көбейтіп және (2)-ші теңдеуді ескере отырып келесі өрнекті аламыз:
         = NI
        
        немесе                           (3)
        
        Магнит өрісі күш сызықтары бетке перпендикуляр болғандықтан, «өзекше - саңылау»бөлімдеріндегі шартты жазамыз, яғни             (4)
        `,
        id_faq: "faq_49",
        for_faq: "faq_49",
        question: `Орташа диаметрі d=0.5 м  болатындай етіп сақина түрінде майыстырған болат өзекше бойынан  I = 3 A тоқ өтетін    N = 800  катушканы құрайды. Сақинада ені  h = 2 мм болатындай саңылау бар. Магнит өрісінің осы саңылаудың шеттерінде шашырауын ескермей отыра, осы саңылаудағы магнит өрісінің В индукциясын және өзекшенің   магниттік өтімділігін табыңыз.
        `,
        img_url: heroImg,
        answers: `#Магниттік ядро
        import matplotlib.pyplot as plt
        import numpy as np
        from scipy import interpolate
        mu0=4*np.pi*1.0e-7;
        x1 = np.array([10,20,50,70,100,200,500,1000],'float')
        y1 = np.array([.04,.14,.48,.62,.74,.92,1.2,1.29])
        f = interpolate.interp1d(x1, y1)
        x2 = np.arange(10, 1000, 0.1)
        y2 = f(x2)
        NV =800; I=3.0; R=0.5; h=0.002;
        A0 = mu0*NV*I/h; A1= mu0*(2*np.pi*R-h)/h;
        x3 = np.arange(10, 700, 0.1)
        y3 =A0-A1*x3;
        plt.plot(x1, y1, 'o', x2, y2, '-',x3, y3, '-')
        plt.xlabel('$H_1$',fontsize=16)
        plt.ylabel('$B$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 49,
        img1: `Снимок экрана (1138).png`,
        img2: `Снимок экрана (1139).png`,
    },
    {
        task_id: "49.1",
        content_title: `Ауадағы магнит өрісінің кернеулігі мен индукциясының арасындағы байланысты    (2) өрнегі арқылы жазамыз.
        – магниттік тұрақты. 
       
       (1)–ші теңдеуді  –ға көбейтіп және (2)-ші теңдеуді ескере отырып келесі өрнекті аламыз:
        = NI
       
       немесе                           (3)
       
       Магнит өрісі күш сызықтары бетке перпендикуляр болғандықтан, «өзекше - саңылау»бөлімдеріндегі шартты жазамыз, яғни  Кестелік деректерден     аралығындағы магниттік индукцияның мәнін анықтау үшін сызықтық интерполяцияны қолданамыз:
       (5)
(5) және (4) жүйелердің шешімін (4) ескере отырып, графикалық тәсілмен қарапайым түрде орындауға болады.  `,
        id_faq: "faq_49.1",
        for_faq: "faq_49.1",
        question: `
        Ауадағы магнит өрісінің кернеулігі мен индукциясының арасындағы байланысты    (2) өрнегі арқылы жазамыз.
 – магниттік тұрақты. 

(1)–ші теңдеуді  –ға көбейтіп және (2)-ші теңдеуді ескере отырып келесі өрнекті аламыз:`,
        img_url: heroImg,
        answers: `#Магниттік ядро
        import matplotlib.pyplot as plt
        import numpy as np
        from scipy import interpolate
        mu0=4*np.pi*1.0e-7;
        x1 = np.array([10,20,50,70,100,200,500,1000],'float')
        y1 = np.array([.04,.14,.48,.62,.74,.92,1.2,1.29])
        f = interpolate.interp1d(x1, y1)
        x2 = np.arange(10, 1000, 0.1)
        y2 = f(x2)
        NV =800; I=3.0; R=0.5; h=0.002;
        A0 = mu0*NV*I/h; A1= mu0*(2*np.pi*R-h)/h;
        x3 = np.arange(10, 700, 0.1)
        y3 =A0-A1*x3;
        plt.plot(x1, y1, 'o', x2, y2, '-',x3, y3, '-')
        plt.xlabel('$H_1$',fontsize=16)
        plt.ylabel('$B$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 49.1,
        img1: `Снимок экрана (1138).png`,
        img2: `Снимок экрана (1139).png`,
    },
];

const structure = [
    {
        name: `МАГНИТОСТАТИКА`,
    },
];

const TaskCompEle = () => {

    return (
        <Fragment>
            <Header />
            {/* {structure.map((item) => (
                <Navmenu item={item} />
            ))} */}

            <br /><br /><br />

            <section>
                <Container className="taskmenu">
                    {taskdata.map((item) => (
                        <TaskCard item={item} />
                    ))}
                </Container>
            </section>
            <Sidebar />
            <Footer />
        </Fragment>
    );
};

export default TaskCompEle;
